'use client';

import Icon from '@/components/icon/Icon';
import LinkNavigationItem from '@/components/linkNavigationItem/LinkNavigationItem';
import {Button} from '@/components/ui/button';
import Wysiwyg from '@/components/wysiwyg/Wysiwyg';
import type Navigation from '@/types/Navigation';
import type {PortableTextProps} from '@portabletext/react';

type ServiceModuleProps = {
  data: Navigation['serviceModule'];
};

export default function ServiceModule({data}: ServiceModuleProps) {
  return (
    <div className="box flex flex-col gap-4 p-4">
      <div className="flex items-center gap-2">
        <Icon name={data.icon} size={48} className="text-primary" />
        <h3 className="flex-1 text-lg font-bold">{data.title}</h3>
      </div>
      <Wysiwyg value={data.description as PortableTextProps['value']} />
      <div className="flex flex-col gap-2">
        {data.ctas.map((cta, index) => (
          <Button asChild key={cta.key} size="sm" variant={index > 0 ? 'outline' : 'default'}>
            <LinkNavigationItem data={cta} />
          </Button>
        ))}
      </div>
    </div>
  );
}
